import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
} from '@chakra-ui/react';
import { ProductApproval } from '@texas/api/endpoints/productApprovalsApi';
import { SharedDisclosureProps } from '@texas/components/shared/types';
import { CustomerProductApprovalDetails } from './CustomerProductApprovalDetails';

interface Props extends SharedDisclosureProps {
  productApproval: ProductApproval;
  refetchAll: () => void;
}

export function CustomerProductApprovalModal({
  productApproval,
  isOpen,
  onClose,
  refetchAll,
}: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="4xl"
      scrollBehavior="inside"
      isCentered={true}
    >
      <ModalOverlay />
      <ModalContent maxW={{ base: 'calc(100vw - 2rem)', lg: '64rem' }}>
        <ModalHeader pr={12}>
          {productApproval.formatNumber}
          <Text fontSize="sm" fontWeight="normal" textTransform="none">
            {productApproval.articleItemCode} · {productApproval.supplierName}
          </Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p={0} overflowX="auto">
          {isOpen && (
            <CustomerProductApprovalDetails
              key={productApproval.id}
              refetchAll={refetchAll}
              id={productApproval.id}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
